<template>
    <div class="main-home" style = "margin-left:20px">
      <HeaderPage style="margin-bottom:30px"/>
      <!-- <video width="400" height="240" controls src="../assets/demo.mp4" style="margin-left:30px;margin-right:30px"></video>
      <video width="400" height="240" controls src="../assets/demo.mp4" style="margin-left:30px;margin-right:30px"></video>
      <video width="400" height="240" controls src="../assets/demo.mp4" style="margin-left:30px;margin-right:30px"></video>
      <video width="400" height="240" controls src="../assets/demo.mp4" style="margin-left:30px;margin-right:30px"></video> -->
      <!-- <video-player class="video-player vjs-custom-skin" 
            ref="videoPlayer" 
            :playsinline="true" 
            :options="playerOptions"
            @play="onPlayerPlay($event)"
            @pause="onPlayerPause($event)"
            @ended="onPlayerEnded($event)"
            @waiting="onPlayerWaiting($event)"
            @playing="onPlayerPlaying($event)"
            @loadeddata="onPlayerLoadeddata($event)"
            @timeupdate="onPlayerTimeupdate($event)"
            @canplay="onPlayerCanplay($event)"
            @canplaythrough="onPlayerCanplaythrough($event)"
            @statechanged="playerStateChanged($event)"
            @ready="playerReadied">
      </video-player> -->
      <!-- <img src="../assets/earth.png" style="width:300px;height:300px;margin-right:50px"> -->
      <!-- <img src="../assets/earth.png" style="width:300px;height:300px;margin-right:50px">
      <img src="../assets/earth.png" style="width:300px;height:300px;margin-right:50px">
      <img src="../assets/earth.png" style="width:300px;height:300px;margin-right:50px"> -->
      <div style="marigin-left:50px;">
        <div style="text-align: left;font-size: 60px;marigin-left:50px;">用户协议</div>
        <div style="text-align: left;font-size: 40px;marigin-left:50px;">No.1</div>
        <div style="text-align: left;font-size: 40px;marigin-left:50px;">No.2</div>
        <div style="text-align: left;font-size: 40px;marigin-left:50px;">No.3</div>
        <div style="text-align: left;font-size: 40px;marigin-left:50px;">No.4</div>
      </div>
    </div>
  </template>
  
  <script>
  import HeaderPage from './HeaderPage.vue';
  // import { videoPlayer } from 'vue-video-player'
  // import 'video.js/dist/video-js.css'
// import videojs from 'video.js'
import 'videojs-contrib-hls'
//   import DataTable from './DataTable.vue';
//   import PaginationWidget from './PaginationWidget.vue'
  
  export default {
    name: 'UserAgreement',
    components:{
      HeaderPage,
      // videoPlayer
    //   DataTable,
    //   PaginationWidget,
    },
    props: {
      msg: String
    },
    data(){
      return{
        // playerOptions: {
        //     playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        //     autoplay: false, // 如果为true,浏览器准备好时开始回放。
        //     muted: false, // 默认情况下将会消除任何音频。
        //     loop: false, // 是否视频一结束就重新开始。
        //     preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        //     language: 'zh-CN',
        //     aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        //     fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        //     sources: [{
        //       type: "video/mp4", // 类型   type: "application/x-mpegURL"直播流
        //       url: 'demo.mp4' // url地址
        //     }],
        //     poster: '', // 封面地址
        //     notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        //     controlBar: {
        //       timeDivider: true, // 当前时间和持续时间的分隔符
        //       durationDisplay: true, // 显示持续时间
        //       remainingTimeDisplay: false, // 是否显示剩余时间功能
        //       fullscreenToggle: true // 是否显示全屏按钮
        //     }
        //   }
      };
    },
    // watch:{
    //   fileList:{
    //     handle(newVal,oldVal){
    //       console.log(111111)
    //     console.log(newVal,oldVal)},
    //     deep:true
        
    //   }
  
    // },
    methods:{
      // 播放回调 视频系列 start
      onPlayerPlay(player) {
          console.log("player play!", player);
        },

        // 暂停回调
        onPlayerPause(player) {
          console.log("player pause!", player);
        },

        // 视频播完回调
        onPlayerEnded($event) {
          console.log(`player`, $event);
        },

        // DOM元素上的readyState更改导致播放停止
        onPlayerWaiting($event) {
          console.log(`player`, $event);
        },

        // 已开始播放回调
        onPlayerPlaying($event) {
          console.log(`player`, $event);
        },

        // 当播放器在当前播放位置下载数据时触发
        onPlayerLoadeddata($event) {
          console.log(`player`, $event);
        },

        // 当前播放位置发生变化时触发。
        onPlayerTimeupdate($event) {
          console.log(`player`, $event);
        },

        //媒体的readyState为HAVE_FUTURE_DATA或更高
        onPlayerCanplay(player) {
          console.log("player Canplay!", player);
        },

        //媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
        onPlayerCanplaythrough(player) {
          console.log("player Canplaythrough!", player);
        },

        //播放状态改变回调
        playerStateChanged(playerCurrentState) {
          //   console.log('player current update state', playerCurrentState);
          if (playerCurrentState.timeupdate > 3 * 60 && this.freeBl) {
            this.$refs.videoPlayer.player.pause();
            this.free = this.freeBl;
          }
        },

        //将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
        playerReadied(player) {
          console.log("example player 1 readied", player);
        }
    }
  }
  
  </script>
  <style>
  .bm-overlay {
    background: #fff;
  }
  .bm-menu {
        height: 50%; /* 100% Full-height */
        width: 0; /* 0 width - change this with JavaScript */
        position: fixed; /* Stay in place */
        z-index: 1000; /* Stay on top */
        top: 0;
        left: 0;
        box-shadow: -1px 0px 10px 0px rgba(0,0,0,0.5);
        background-color: #ffffff; /* Black*/
        overflow-x: hidden; /* Disable horizontal scroll */
        padding-top: 60px; 
        transition: 0.5s; 
      }
      input#file-upload-button{
    display: none;
  }
  </style>
  <style lang="less" scoped>
  
  /deep/ .bm-burger-button{
        height: 15px;
        width:20px;
  }
  /deep/ .line-style{
        position: absolute;
        height: 20%;
        width:15px;
        left: 0;
        right: 0;
      }
  .hamburger{
      .cross-style {
        position: absolute;
        top: 12px;
        right: 2px;
        cursor: pointer;
      }
      .bm-cross {
        background: #bdc3c7;
      }
      .bm-cross-button {
        height: 24px;
        width: 24px;
      }
      // .bm-menu {
      //   height: 100%; /* 100% Full-height */
      //   width: 0; /* 0 width - change this with JavaScript */
      //   position: fixed; /* Stay in place */
      //   z-index: 1000; /* Stay on top */
      //   top: 0;
      //   left: 0;
      //   background-color: rgb(63, 63, 65); /* Black*/
      //   overflow-x: hidden; /* Disable horizontal scroll */
      //   padding-top: 60px; /* Place content 60px from the top */
      //   transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
      // }
   
      .bm-overlay {
        background: #fff;
      }
      .bm-item-list {
        color: #b8b7ad;
        margin-left: 10%;
        font-size: 20px;
      }
      .bm-item-list > * {
        display: flex;
        text-decoration: none;
        padding: 0.7em;
      }
      .bm-item-list > * > span {
        margin-left: 10px;
        font-weight: 700;
        color: white;
      }
    }
  .category-box{
      display: flex;
      font-size: 14px;
      .category-label{
          min-width: 50px;
          color: #999;
          padding-top: 3px;
          padding-right: 15px;
      }
      .category-list{
          display: flex;
          flex-flow: row wrap;
          align-items: center;
  
          .category-item {
              margin: 0 10px 5px 0;
              padding: 4px 10px;
              color: #666;
              border-radius: 12px;
              outline: none;
              cursor: pointer;
              &-active{
                  color: #ff7752;
                  font-weight: 500;
                  background-color: #ddebf8;
              }
          }
      }
  }
  .flex-1 {
      flex: 1;
  }
  .category-two-menu-box.el-tooltip__popper.is-light{
      box-shadow: 0 2px 12px 0 #e1e3e6;
      border: 1px solid #f0f0f0;
  }
  .category-two-menu-box.el-tooltip__popper {
      padding: 0;
  }
  .category-two-menu-box .el-cascader-node:hover {
      color: #ff7752;
  }
  .category-two-menu-box .el-cascader-node.is-active {
      color: #ff7752;
  }
  .category-two-menu-box.el-tooltip__popper.is-light .el-cascader-panel.is-bordered {
      border-radius: 0;
      border: 0 none;
  }
  .category-two-menu-box.el-tooltip__popper.is-light .popper__arrow {
      border-bottom-color: #f0f0f0!important;
  }
  </style>
  
